import api from 'Application/api/api';

const activateEmployee = (id, cancelToken = null) =>
    api.post(`/employees/${id}/activate`, {}, { cancelToken });

export default activateEmployee;
